import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import { addTeamUserAction, deleteTeamUserAction, teamDeleteAction, teamViewAction } from '../../redux/actions/teamAction';
import { Spinner } from 'react-bootstrap';
import { IoArrowBack } from 'react-icons/io5';
import moment from 'moment';
import CustomButton from '../../components/button/button';
import successToast from '../../components/toasts/successToast';
import AddTeamUserModal from '../../components/modals/team/addUsers';
import { availableLanguages } from '../../components/data/languageData';
import DeleteConfirmModal from '../../components/modals/confirmation/delete-confirmation-modal';
import { formatDateTime, getLangName } from '../../components/helper';
import { useAuth } from '../../context/AuthContext';

const ViewTeam = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [teamData, setTeamData] = useState({});
    const { id } = useParams();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [showDeleteModal, setshowDeleteModal] = useState(false);
    const { isAdmin } = useAuth();

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const onViewSuccess = (data) => {
        setTeamData(data.data.data);
        setLoading(false);
    };

    const onViewError = (data) => {
        errorToast(data.data.message);
        setLoading(false);
        closeModal();
    };

    useEffect(() => {
        if (id) {
            setLoading(true);
            dispatch(teamViewAction({ id }, onViewSuccess, onViewError));
        }
    }, [id, dispatch]);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    const handleRemoveUser = (id, team_id) => {
        setLoading(true);
        dispatch(deleteTeamUserAction({ id, team_id }, onSuccess, onViewError));
    };
    const onSuccess = (data) => {
        dispatch(teamViewAction({ id }, onViewSuccess, onViewError));
        successToast(data?.data?.message);
    };

    const handleAddUser = (team_users) => {
        if (id) {
            dispatch(addTeamUserAction({ id, team_users }, onAddSuccess, onViewError));
        }
    };

    const onAddSuccess = (data) => {
        setLoading(true);
        dispatch(teamViewAction({ id }, onViewSuccess, onViewError));
        successToast(data?.data?.message);
        closeModal();
    };

    const handleDeleteClick = (id) => {
        setLoading(true);
        dispatch(teamDeleteAction({ id }, onDeleteSuccess, onViewError));
    };

    const onDeleteSuccess = (data) => {
        successToast(data?.data?.message);
        navigate(-1);
    };
    /* ── Access guard ── */
    if (!isAdmin) {
        return (
            <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <i className="bi bi-shield-lock fs_40 text-danger mb-3"></i>
                <h5 className="fw_600">Access Denied</h5>
                <p className="text-muted fs_14">This page is only accessible to company administrators.</p>
            </div>
        );
    }
    return (
        <div className="d-flex vh-100 overflow-auto" onClick={handleClickOutside}>
            <div className="w-100 ">
                <div className="w-100 d-flex gap-1 align-items-center header border-bottom position-sticky top-0 bg-white py-2 justify-content-between">
                    <div className='d-flex'>
                        <span className="px-1 fs_16 cursor_pointer" onClick={() => navigate(-1)}><IoArrowBack /></span>
                        <h2 className="fs_20 fw_400 fn_Roboto text-start px-2 text-nowrap">View Team</h2>
                    </div>
                    <div className='d-flex'>
                        <CustomButton className='cursor_pointer fs_18 pb-1 mx-2 d-flex align-items-center justify-content-center text-nowrap'
                            variant='danger' onClick={() => { setshowDeleteModal(true) }}>
                            Delete Team
                        </CustomButton>
                        <CustomButton
                            className='cursor_pointer fs_18 pb-1 me-5 d-flex align-items-center justify-content-center text-nowrap'
                            variant="primary" style={{ width: "6rem" }}
                            onClick={() => { navigate(`/edit-team/${id}`) }}>
                            Edit
                        </CustomButton>
                    </div>
                </div>
                {loading ?
                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "90%" }}>
                        <Spinner animation="border" variant="primary" /> <span>Loading...</span>
                    </div>
                    :
                    <div className="flex-grow-1 pt-1">
                        <div className="text-start p-3 d-flex flex-column w-100 overflow-auto gap-3">
                            <div className='d-flex gap-5 flex-wrap'>
                                <div>
                                    <label className="pb-1" >Team Name</label> <br />
                                    <input type='text' style={{ width: "20rem" }} value={teamData?.name} disabled className='input-field' />
                                </div>
                                <div>
                                    <label className="pb-1" >Team Lead</label> <br />
                                    <input type='text' style={{ width: "20rem" }} value={teamData?.teamLead?.email} disabled className='input-field' />
                                </div>
                                <div >
                                    <label className="pb-1" >Description </label> <br />
                                    <input title={teamData?.description} style={{ width: "20rem" }} value={teamData?.description !== '' ? teamData?.description : "--"} disabled className='input-field' />
                                </div>
                            </div>
                            <div style={{ maxWidth: "66rem" }}>
                                <div className='d-flex gap-4 align-items-center mb-2'>
                                    <h5 >Team Users</h5>
                                    <span className="fs_16 fw_600 cursor_pointer text-primary" onClick={openModal}> Add Users</span>
                                </div>
                                <div className="table-responsive overflow-auto w-100" >
                                    <table className="table table-bordered">
                                        <thead className="table-light">
                                            <tr className="text-start text-nowrap">
                                                <th width={'30%'} className='fw_400'>User</th>
                                                <th width={'30%'} className='fw_400'>Joined Date</th>
                                                <th width={'30%'} className='fw_400 text-center'>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="3">Loading...</td>
                                                </tr>
                                            ) : teamData?.teamUsers?.length > 0 ? (
                                                teamData?.teamUsers?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className='fs_14'>
                                                            {item?.user?.email}
                                                        </td>
                                                        <td className='fs_14'>
                                                            {moment(item?.createdAt).format('MM/DD/YY, hh:mm A')}
                                                        </td>
                                                        <td className='fs_14 text-danger text-center cursor_pointer'
                                                            onClick={() => { handleRemoveUser(item.id, teamData.id) }}>
                                                            Remove
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className='text-center' colSpan="3">No rows to display</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ maxWidth: "75rem" }}>
                                <h5 >Assigned Documents</h5>
                                <div className="table-responsive overflow-auto w-100" style={{ minWidth: '40rem' }}>
                                    <table className="table table-bordered">
                                        <thead className="table-light">
                                            <tr className="text-start text-nowrap">
                                                <th width={'20%'} className='fw_400'>Document Name</th>
                                                <th width={'18%'} className='fw_400'>Source Language</th>
                                                <th width={'18%'} className='fw_400'>Target Language</th>
                                                <th width={'15%'} className='fw_400'>Target Date</th>
                                                <th width={'14%'} className='fw_400'>Assigned By</th>
                                                <th width={'15%'} className='fw_400'>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="3">Loading...</td>
                                                </tr>
                                            ) : teamData?.assignedTeams?.length > 0 ? (
                                                teamData?.assignedTeams?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className='fs_14'>
                                                            {item?.document?.name}
                                                        </td>
                                                        <td className='fs_14'>
                                                            {getLangName(item?.document?.source_lang)} ({item?.document?.source_lang})
                                                        </td>
                                                        <td className='fs_14'>
                                                            {item?.target_lang?.map((lang) => `${getLangName(lang)} (${lang})`).join(", ")}
                                                        </td>
                                                        <td className='fs_14'>
                                                            {formatDateTime(item?.target_date)}
                                                        </td>
                                                        <td className='fs_14'>
                                                            {item?.assignedBy?.email}
                                                        </td>
                                                        <td className='fs_14'>
                                                            {item?.document?.status}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className='text-center' colSpan="6">No rows to display</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <AddTeamUserModal isOpen={isModalOpen} onClose={closeModal} onSave={handleAddUser} />
            <DeleteConfirmModal
                isOpen={showDeleteModal}
                onClose={() => setshowDeleteModal(false)}
                deletConfirmationMsg={`Are you sure you want to delete ${teamData?.name} Team and all its related data?`}
                type={"Team"}
                onDelete={handleDeleteClick}
                id={id}
            />
        </div>
    );
};

export default ViewTeam;

